module.exports = __webpack_public_path__ + "static/img/demo_1_or.5c774461.png";